import { render, staticRenderFns } from "./PropertiesPanel.vue?vue&type=template&id=6da4e82a&"
import script from "./PropertiesPanel.vue?vue&type=script&lang=js&"
export * from "./PropertiesPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports